import * as React from 'react';
import { Container, Row, Col, Card, IconButton, Button } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { ChevronRight } from 'wix-ui-icons-common';
import * as css from './drill-in-section.scss';

export interface Props {
  title: string;
  subtitle?: string;
  buttonText?: string;
  dataHook?: string;
  disabled?: boolean;
  onDrillIn(): void;
}

export const DrillInSection = ({ onDrillIn, title, subtitle, buttonText, dataHook, disabled = false }: Props) => {
  const renderDrillInButton = () =>
    buttonText ? (
      <Button
        dataHook={DataHooks.DrillInSectionDrill}
        className={css.button}
        onClick={onDrillIn}
        suffixIcon={<ChevronRight />}
        priority="secondary"
        disabled={disabled}
      >
        {buttonText}
      </Button>
    ) : (
      <IconButton
        dataHook={DataHooks.DrillInSectionDrill}
        priority="secondary"
        skin="standard"
        onClick={onDrillIn}
        disabled={disabled}
      >
        <ChevronRight />
      </IconButton>
    );

  return (
    <Container className={disabled ? css.disabled : ''}>
      <Row dataHook={dataHook}>
        <Col>
          <Card dataHook={DataHooks.DrillInSectionContainer}>
            <Card.Header
              dataHook={DataHooks.DrillInSectionHeader}
              title={title}
              subtitle={subtitle}
              suffix={renderDrillInButton()}
            />
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
